import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  getCuenta,
  getMovimientos,
} from "../../../../app/store/actions/cuentaActions";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { Grid, Container, Button } from "semantic-ui-react";
import CuentaDetailInfo from "./CuentaDetailInfo";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CuentaDetailHeader from "./CuentaDetailHeader";
import { NUMERO_MOVIMIENTOS_CONSULTA_DEFAULT } from "../../../../app/infrastructure/appConstants";
import { decryptValueFromBase64Url } from "../../../../app/util/decryptUtil";

const mapState = (state) => ({
  cuenta: state.cuentaReducer.cuenta,
  loadingCuenta: state.cuentaReducer.loadingCuenta,
  currentUser: state.auth.currentUser,
  movimientos: state.cuentaReducer.movimientos,
  loadingMovimientos: state.cuentaReducer.loadingMovimientos,
});

const actions = {
  getCuenta,
  getMovimientos,
};

const CuentaDetailsPage = ({
  match,
  getCuenta,
  cuenta,
  loadingCuenta,
  getMovimientos,
  movimientos,
  loadingMovimientos,
}) => {
  useEffect(() => {
    const IdCuenta = decryptValueFromBase64Url(match.params.id);
    getCuenta({ cuenta: IdCuenta });
  }, [getCuenta, match.params.id]);

  useEffect(() => {
    const IdCuenta = decryptValueFromBase64Url(match.params.id);
    getMovimientos(
      { cuenta: IdCuenta,
        movimientos: NUMERO_MOVIMIENTOS_CONSULTA_DEFAULT
      });
  }, [getMovimientos, match.params.id]);

  if (loadingCuenta)
    return <LoadingComponent content="Cargando cuenta..." />;
  if (loadingMovimientos) return <LoadingComponent content="Cargando movimientos..." />;
  return (
    <Container className="containerPrincipal">
      <Grid>
        {cuenta && (
          <>
            <Grid.Row>
              <Grid.Column>
                <CuentaDetailHeader cuenta={cuenta} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <CuentaDetailInfo cuenta={cuenta} movimientos={movimientos} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
                <Button
                  fluid
                  content="Atrás"
                  as={Link}
                  to="/cuentas"
                  color="blue"
                  size="large"
                />
              </Grid.Column>
              <Grid.Column computer={8} largeScreen={8} mobile={2} tablet={4} />
              <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
              </Grid.Column>
            </Grid.Row>
          </>
        )}
      </Grid>
    </Container>
  );
};

CuentaDetailsPage.propTypes = {
  match: PropTypes.object.isRequired,
  getCuenta: PropTypes.func.isRequired,
  cuenta: PropTypes.object,
  loadingCuenta: PropTypes.bool.isRequired,
  getMovimientos: PropTypes.func.isRequired,
  movimientos: PropTypes.array.isRequired,
  loadingMovimientos: PropTypes.bool.isRequired,
};
export default connect(mapState, actions)(CuentaDetailsPage);
